"use strict";
/*
 * Created on 18. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MailEvent_1 = require("../MailEvent");

var MailEventConverter_1 = require("./MailEventConverter");
/**
 * Default implementation of {@link MailEventConverter}.
 *
 * @author Radek Beran
 */


var MailEventConverterImpl =
/*#__PURE__*/
function (_MailEventConverter_) {
  _inherits(MailEventConverterImpl, _MailEventConverter_);

  function MailEventConverterImpl() {
    _classCallCheck(this, MailEventConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MailEventConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(MailEventConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new MailEvent_1.MailEvent(conversions.documentToClassId(source), MailEvent_1.MailEvent.schema.entityId.valueOf(conversions.toClassReferenceId(source.entityId)), MailEvent_1.MailEvent.schema.eventType.valueOfField(source), MailEvent_1.MailEvent.schema.subject.valueOfField(source), MailEvent_1.MailEvent.schema.to.valueOf(conversions.asObjectList(source, 'to', function (email) {
        return email;
      })), MailEvent_1.MailEvent.schema.sent.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      document = Object.assign(document, conversions.classToDocumentId(source));
      document = Object.assign(document, {
        entityId: conversions.toDocumentReferenceId(source.entityId),
        eventType: source.eventType,
        subject: source.subject,
        to: conversions.asObjectArray(source, 'to', function (email) {
          return email;
        }),
        sent: conversions.fromDate(source.sent)
      });
      return document;
    }
  }]);

  return MailEventConverterImpl;
}(MailEventConverter_1.MailEventConverter);

exports.MailEventConverterImpl = MailEventConverterImpl;